module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.2.1-rc.4-94.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.2.1-rc.4.md
// module id = 511
// module chunks = 320